/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import HeaderLogo from 'bundles/page-header/components/HeaderLogo';

import _t from 'i18n!nls/widget-simulator';

import 'css!./__styles__/PageHeader';
import 'css!bundles/page-header/components/__styles__/PageHeader';

const styles = {
  gridContainer: css`
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;

    &::before,
    &::after {
      display: table;
      content: ' ';
    }

    &::after {
      clear: both;
    }
  `,
  navContainer: css`
    .bt3-navbar::before .bt3-navbar::after {
      content: ' ';
      display: table;
    }

    .bt3-navbar::after {
      clear: both;
    }

    .bt3-navbar {
      min-height: 50px;
    }
  `,
};

const PageHeader = () => (
  <div css={styles.navContainer}>
    <div className="rc-PageHeader rc-DesktopHeaderControls">
      <div className="bt3-navbar c-ph-nav full-width">
        <div css={styles.gridContainer} className="c-container horizontal-box">
          <HeaderLogo enableCourseraLogoOnly logoWrapper="div" />
          <h4 className="align-items-vertical-center horizontal-box app-name">
            <div className="divider" />
            {_t('Plugin Development Simulator')}
          </h4>
        </div>
      </div>
    </div>
  </div>
);

export default PageHeader;
